import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Home';
import Login from '@/views/Login';
import Module from '@/views/Module';
import Task from '@/views/Task';
import Quiz from '@/views/Quiz';
import NotFound from '@/views/NotFound';

// import Messages from '@/views/Messages';
// import About from '@/views/About';
// import Jobs from '@/views/jobs/Jobs';
// import JobDetails from '@/views/jobs/JobDetails';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		// Views
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			// path: '/:moduleName(module-[0-9])',
			path: '/:moduleName([a-z]+)',
			name: 'Module',
			component: Module,
			props: true
		},
		{
			// path: '/:moduleName(module-[0-9])/:taskName(task-[0-9][a-z]?)',
			path: '/:moduleName([a-z]+)/:taskName(task-[0-9][a-z]?)',
			name: 'Task',
			component: Task,
			props: true
		},
		{
			// path: '/:moduleName(module-[0-9])/:taskName(quiz-[0-9][a-z]?)',
			path: '/:moduleName([a-z]+)/:taskName(quiz-[0-9][a-z]?)',
			name: 'Quiz',
			component: Quiz,
			props: true
		},
		{
			path: '/:catchAll(.*)',
			name: 'NotFound',
			component: NotFound
		}


		// Redirect example
		// {
		// 	path: '/old-url',
		// 	redirect: '/jobs'
		// },

	]
});

// Alt. way of doing this?
// const router = createRouter({
	// history: createWebHistory(process.env.BASE_URL),
	// routes
// });

